var map = {
	"./template.betgalaxy": 1069,
	"./template.betgalaxy.tsx": 1069,
	"./template.betprofessor": 1070,
	"./template.betprofessor.tsx": 1070,
	"./template.betroyale": 2104,
	"./template.betroyale.tsx": 2104,
	"./template.default": 655,
	"./template.default.tsx": 655,
	"./template.fiestabet": 2006,
	"./template.fiestabet.tsx": 2006,
	"./template.forsport": 1071,
	"./template.forsport.tsx": 1071,
	"./template.puntcity": 1072,
	"./template.puntcity.tsx": 1072,
	"./template.puntgenie": 1073,
	"./template.puntgenie.tsx": 1073,
	"./template.questbet": 1074,
	"./template.questbet.tsx": 1074,
	"./template.ts": 286,
	"./template.volcanobet": 1075,
	"./template.volcanobet.tsx": 1075,
	"./template.wellbet": 2105,
	"./template.wellbet.tsx": 2105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2412;